import type { ReactNode } from 'react';
import { DialogTitle, IconButton, Box, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/useIsMobile';

interface DialogHeaderProps {
  title?: string;
  icon?: ReactNode;
  extra?: ReactNode;
  children?: ReactNode;
  onClose?: () => void;
  closeDisabled?: boolean;
}

export function DialogHeader({
  title,
  icon,
  extra,
  children,
  onClose,
  closeDisabled,
}: DialogHeaderProps) {
  const { t: tc } = useTranslation('common');
  const isMobile = useIsMobile();

  if (isMobile) return null;

  return (
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {children ?? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          {icon}
          <span>{title}</span>
          {extra}
        </Box>
      )}
      {onClose && (
        <Tooltip title={tc('close')}>
          <span>
            <IconButton
              aria-label={tc('close')}
              onClick={onClose}
              disabled={closeDisabled}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </DialogTitle>
  );
}
